import { supabase } from "../supabase/SupabaseClient";
import { actual } from "./quien";

/* Seguimiento médico de siniestros de la ART (P-173, Natalia).
 *
 * El parseo del export vive en `shared/artSeguimiento` (puro, con tests); acá
 * está sólo lo que pega contra la base. Mismo muro que el resto de RRHH: la RLS
 * pide `ver.rrhh` para leer y `cargar.rrhh` para escribir — este archivo no lo
 * chequea, lo hace la base (sin la llave, cero filas / rechazo).
 */

/* El seguimiento cargado de una persona, del turno más nuevo al más viejo. */
export async function traerSeguimientoArt(dni) {
  const d = String(dni ?? "").replace(/\D/g, "");
  if (!d) return [];
  const { data, error } = await supabase
    .from("art_seguimientos")
    .select("id,fecha_turno,motivo,diagnostico,evolucion,creado_en")
    .eq("dni", d)
    .order("fecha_turno", { ascending: false, nullsFirst: false })
    .order("id", { ascending: false })
    .limit(500);
  if (error) throw error;
  return data || [];
}

/* Guarda las filas parseadas del export para una persona.
 *
 * IDEMPOTENTE Y ADITIVO: upsert con `ignoreDuplicates` sobre (dni, firma), así
 * re-subir el mismo archivo no duplica y subir uno más nuevo suma sólo lo que
 * falta. Devuelve cuántas entraron de cuántas se intentaron. */
export async function guardarSeguimientoArt(dni, filas) {
  const d = String(dni ?? "").replace(/\D/g, "");
  if (!d) throw new Error("Falta la persona");
  const quien = actual();
  const rows = (filas || [])
    .filter((f) => f && (f.fecha_turno || (f.evolucion || "").trim()))
    .map((f) => ({
      dni: d,
      fecha_turno: f.fecha_turno || null,
      motivo: (f.motivo || "").trim() || null,
      diagnostico: (f.diagnostico || "").trim() || null,
      evolucion: (f.evolucion || "").trim() || null,
      firma: f.firma,
      origen: "planilla-art",
      cargado_por: quien?.mail || null,
    }));
  if (rows.length === 0) return { insertados: 0, total: 0 };
  const { data, error } = await supabase
    .from("art_seguimientos")
    .upsert(rows, { onConflict: "dni,firma", ignoreDuplicates: true })
    .select("id");
  if (error) throw error;
  return { insertados: (data || []).length, total: rows.length };
}
